import { useState } from "react";
import { truncate } from "../../utils/truncate";
import UpgradePremiumPopup from "../UpgradePremiumPopup";
import "./CommunitiesCard.css";

const CommunitiesCard = ({ content }) => {
  const [upgradePremium, setUpgradePremium] = useState(false);
  const { plan } = JSON.parse(localStorage.getItem("gsprklUserInfo"));

  const handleClickCommunities = (e) => {
    e.preventDefault();
    if (plan === "free-plan") {
      setUpgradePremium(true);
    }
  };

  return (
    <>
      <a
        href={`${
          plan !== "free-plan"
            ? content.id === 1
              ? "https://discord.com/invite/WtVzunkDHE"
              : "https://discord.com/app"
            : window.location.href
        }`}
        target={plan !== "free-plan" ? "_blank" : "_parent"}
        rel="noreferrer"
        onClick={handleClickCommunities}
      >
        <div
          className={`communitiesCard flex-row ${
            plan === "free-plan" && "communities-lock"
          }`}
        >
          <img src={content.img} alt={content.title} />
          <div>
            <h3>{content.title}</h3>
            <span>{content.subtitle}</span>
            <p>{truncate(content.description, 96)}</p>
          </div>
        </div>
      </a>
      {upgradePremium && (
        <UpgradePremiumPopup closePopup={() => setUpgradePremium(false)} />
      )}
    </>
  );
};

export default CommunitiesCard;
